import { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledTextField } from 'library/components/controls/form/ControlledTextField';
import { IdentifiersContainer } from 'modules/UnitOverview/UnitInformation/Components/IdentifiersContainer';

export const IdentifiersIndustrialSection = memo(() => {
	const { control } = useFormContext();
	const { t } = useTranslation(['unitCreation', 'commonUnit']);

	return (
		<IdentifiersContainer
			title={t('unitCreation:unit-information-identifiers-title')}>
			<ControlledTextField
				id="text-field-machine-id"
				label={t('commonUnit:machine-id')}
				control={control}
				name="machineId"
				size="small"
				validation={{
					required: 'common:validation-message-valid-identifier',
				}}
			/>
		</IdentifiersContainer>
	);
});
